import classNames from 'classnames'

interface Props {
  className?: string
}
const Divider = ({ className = '' }: Props) => {
  return <div className={classNames(className, 'border-t-1 h-[8px] w-full border-gray-100 bg-gray-50')}></div>
}

export default Divider
